import {
  getHireLocationsConvertibleShiftsRetrieveQueryOptions,
  getHireLocationsWeeklyPatternRetrieveQueryOptions,
  getLocationsRetrieveQueryOptions,
  hireLocationsWorkingInterviewSeriesPreviewCreate,
  type WorkingInterviewSeriesPreviewRequestRequest,
} from "@sidegigllc/api/client";
import { queryOptions } from "@tanstack/react-query";

type QueriesInput = {
  locationId: number;
  skillId: number | undefined;
  /** Off until the business reaches the step: the dialog mounts it on open. */
  enabled: boolean;
};

/** The location's timezone, which the schedule is read and sent in. */
export const locationQuery = ({ locationId }: Pick<QueriesInput, "locationId">) =>
  getLocationsRetrieveQueryOptions(locationId);

/** C3's suggested weekly pattern for the role at the location; `pattern` is null without history. */
export const weeklyPatternQuery = ({ locationId, skillId, enabled }: QueriesInput) =>
  getHireLocationsWeeklyPatternRetrieveQueryOptions(
    locationId,
    { skill_id: skillId },
    { query: { enabled: enabled && skillId != null } },
  );

/** The location's upcoming open shifts for the role that can become working interviews (C4, WORK-9549). */
export const convertibleShiftsQuery = ({ locationId, skillId, enabled }: QueriesInput) =>
  getHireLocationsConvertibleShiftsRetrieveQueryOptions(
    locationId,
    { skill_id: skillId },
    { query: { enabled: enabled && skillId != null } },
  );

/**
 * How many working interviews a series would post, and when: C2's preview keyed by location (C4, WORK-9549), since
 * the step runs before the job exists. A POST that creates nothing, so it's read as a query keyed on the request:
 * the count follows the form as it changes.
 */
export const seriesPreviewQuery = ({
  locationId,
  request,
  enabled,
}: Pick<QueriesInput, "locationId" | "enabled"> & {
  request: WorkingInterviewSeriesPreviewRequestRequest | undefined;
}) =>
  queryOptions({
    queryKey: ["hire", "locations", locationId, "working-interview-series", "preview", request],
    queryFn: ({ signal }) => {
      if (!request) throw new Error("No series to preview");
      return hireLocationsWorkingInterviewSeriesPreviewCreate(locationId, request, { signal });
    },
    enabled: enabled && request != null,
    // A refusal (no day between the dates) is an answer, not a flaky request.
    retry: false,
  });
